import React from 'react'

import HeaderNew from 'presentation/shared/components/HeaderNew'
import SelectOPMEForm from 'presentation/doctor/components/Forms/AddSurgicalOrderNew/SelectOPME'

const SelectOPMELayout = () => {
  return (
    <>
      <HeaderNew actualPageTitle="Novo pedido cirúrgico - Procedimentos e CID" />
      <SelectOPMEForm />
    </>
  )
}

export default SelectOPMELayout
